import api from "../../../api";

export function validateData(payload){
    return api.post("validate-transfer", payload);
}

export function transferCusUpload(payload){
    return api.post("transfer-customers", payload)
}